import React from "react";
import styled from "styled-components";

export default styled.input`
    line-height: 24px;
    width: 100%;
    text-align: center;
    display: inline-block;
    margin: 0 auto;
    border: 1px solid #979797;
    box-sizing: border-box;
    text-align: left;
    
    color: #717198;
   margin-bottom: 8px;
    height: 38px;
    font-size: 16px;
    padding: 4px 11px;
    border: .5px solid lightgrey;
`;